import { FC, useState } from 'react';

type MediaUploadIndicatorProps = {
  percentage: number;
};

const MediaUploadIndicator: FC<MediaUploadIndicatorProps> = ({ percentage }) => {
  const [step, setStep] = useState(0);
  const radius = 15; // Radius of the circle
  const circumference = 2 * Math.PI * radius; // Circumference of the circle
  const offset = circumference - (percentage / 100) * circumference; // Offset to control the completed portion
  const strokeWidth = 3; // Stroke width of the circle
  const svgSize = radius * 2 + strokeWidth; // Calculate the SVG size based on the radius and stroke width
  const viewBoxSize = svgSize + strokeWidth; // Adjust the viewBox size to account for the stroke width

  return (
    <svg
      className="animate-spin -ml-1 mr-3 h-5 w-5 text-black"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>

    //   <svg
    //   className="circle-progress"
    //   width={svgSize}
    //   height={svgSize}
    //   viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
    // >
    //   <circle
    //     className="circle-progress-background"
    //     cx={svgSize / 2}
    //     cy={svgSize / 2}
    //     r={radius}
    //     fill="none"
    //     stroke="white"
    //     strokeWidth={strokeWidth}
    //   />
    //   <circle
    //     className="circle-progress-foreground transition-all"
    //     cx={svgSize / 2}
    //     cy={svgSize / 2}
    //     r={radius}
    //     fill="none"
    //     stroke="black"
    //     strokeWidth={strokeWidth}
    //     strokeDasharray={circumference}
    //     strokeDashoffset={offset}
    //   />
    // </svg>
  );
};

export default MediaUploadIndicator;
